import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const ShufflingSpeed = () => {
  const { speed } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (parseInt(speed)) localStorage.setItem('shufflingSpeed', speed)

    navigate('/')
  }, [navigate, speed])
}

export default ShufflingSpeed
